export default __webpack_public_path__ + "static/milksha-global-f5e11ab611c26590d0e7263a7d77cbdb.jpg";